import type { ReactNode } from 'react';

export const symbol_flowchart: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M614-160v-83H450v-207H345v83H80v-226h265v83h105v-207h164v-83h266v226H614v-83H510v354h104v-82h266v225H614Zm60-60h146v-105H674v105ZM140-427h145v-106H140v106Zm534-207h146v-106H674v106Zm0 414v-105 105ZM285-427v-106 106Zm389-207v-106 106Z"
		/>
	</svg>
);
